export const SHIPMENT_REVIEW = {
    RESET_GRID_VIEW: "RESET_GRID_VIEW",
    SEARCH_FILED: "SEARCH_FILED",
    CLEAR_SEARCH: "CLEAR_SEARCH",
    GRID_VIEW_FILTERED_TOTALS: "GRID_VIEW_FILTERED_TOTALS",
    GRID_VIEW_TOTALS: "GRID_VIEW_TOTALS",
    EMPTY_SIZE_FIELD: "EMPTY_SIZE_FIELD",
    SIZE_FIELD_QUANTITY: "SIZE_FIELD_QUANTITY",
    SHIPMENT_MODE_ICON: "SHIPMENT_MODE_ICON",
    BULK_UNITS: {
        UNITS: "BULK_UNITS_UNITS",
        SIZED: "BULK_UNITS_SIZED",
    },
    SIZE_FIELD_INVENTORY: "SIZE_FIELD_INVENTORY",
    NAME_LINK_VALUE: "NAME_LINK_VALUE",
    SIZING_VIEW: {
        PRIMARY_IMAGE: "PRIMARY_IMAGE",
        NO_IMAGE: "NO_IMAGE",
        ROW_IMAGE_CELL: "ROW_IMAGE_CELL",
        GRID_WRAPPER: "GRID_WRAPPER",
    },
    DETAILS_HEADER_PRICE: "DETAILS_HEADER_PRICE",
};
